export const Container = ({ children, className = "" }) => (
  <div className={`mx-auto max-w-[var(--container-max)] px-4 sm:px-6 lg:px-8 ${className}`}>
    {children}
  </div>
);

export const Eyebrow = ({ children, className = "" }) => (
  <span
    className={`inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-primary ${className}`}
  >
    <span className="h-1.5 w-1.5 rounded-full bg-primary" />
    {children}
  </span>
);

export const SectionHeading = ({
  eyebrow,
  title,
  description,
  align = "left",
  className = "",
}) => (
  <div
    className={`${align === "center" ? "mx-auto max-w-2xl text-center" : "max-w-2xl"} ${className}`}
  >
    {eyebrow && <Eyebrow className={align === "center" ? "justify-center" : ""}>{eyebrow}</Eyebrow>}
    <h2 className="mt-4 text-3xl font-semibold leading-tight tracking-[-0.02em] sm:text-4xl">
      {title}
    </h2>
    {description && (
      <p className="mt-4 text-base leading-relaxed text-muted-foreground">
        {description}
      </p>
    )}
  </div>
);

export default Container;
